import { masterClient } from '~/core/utils/clients/masterClient'

export type FavouritesFolder = {
  id: number,
  name: string,
  doctorsCount: number,
  doctorsInfo: { idProdoctorov: number, avatar: string}[]
}

export type FavouriteFoldersDTO = {
  foldersCount: number,
  favoriteFolders: FavouritesFolder[]
}

export type FolderDoctorInfoDTO = {
  idProdoctorov: number,
  name: string,
  avatar: string,
  specialities: string[],
  rating: number,
  ratesCount: number,
  urlPath: string,
}

export type FavouritesFolderDataDTO = {
  name: string,
  doctorsInfo: FolderDoctorInfoDTO[]
}

const RESOURCE = '/favourites/folders'

export const FavouriteFoldersApi = {
  get() {
    return masterClient.get<FavouriteFoldersDTO>(RESOURCE, { camelize: true })
  },
  getFolderData(id: number) {
    return masterClient.get<FavouritesFolderDataDTO>(`${RESOURCE}/${id}/`, { camelize: true })
  },
  deleteDoctorFromFolder(folderId: number, doctorId: number) {
    return masterClient.delete(`${RESOURCE}/${folderId}/doctors/`, {
      camelize: true,
      data: {
        doctorIds: [doctorId],
      },
    })
  },
  addDoctorToFolder(folderId: number, doctorId: number) {
    return masterClient.post(`${RESOURCE}/${folderId}/doctors/`, {
      doctorIds: [doctorId],
    }, {
      camelize: true,
    })
  },
}
